import TableWithFilter from 'components/InternalRequest/Summary/tableWithFilter'

export default function MyRequest() {
  return <TableWithFilter pageInset={205} retainFilter={true} tab={'myrequest'} />
}
